import Topnavbar from "../../sections/Topnavbar"
import { Helmet, HelmetProvider } from "react-helmet-async";
import DashInventario from "./DashInventario";
import GraficoUltimasOtms from "./GraficoUltimasOTMS";
import Leftnavbar from "../../sections/Leftnavbar";
import MensajeModal from "../../MensajeModal.js/MensajeModal";
import Footerbar from "../../sections/Footerbar";

const Dashboard = () => {
    
    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <title>DASHBOARD</title>
                </Helmet>
            </HelmetProvider>
            <Leftnavbar />
            <Topnavbar />
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0">Dashboard</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="#">Home</a></li>
                                    <li className="breadcrumb-item active">Dashboard</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="content">
                    <div className="container-fluid">                        
                        <div className="row">
                            <div className="col-md-12">
                                <DashInventario />
                            </div>
                        </div>
                        {/*<div className="row">
                            <div className="col-md-12">
                                <GraficoUltimasOtms />
                            </div>
                        </div>*/}
                    </div>
                </section>
            </div>            
            <Footerbar />
        </>
    )
}
export default Dashboard